import { HttpV1 as HTTP } from '@/request'

/**
 * 获取折扣汇总信息
 */
export async function getRebateSumInfo ({ token, endTime, startTime, ...rest }) {
  const data = await HTTP.get(`/agent/rebate/detail`, { token, endTime, startTime, ...rest })
  return data
}